import React from 'react';

export const useBoxSize = (element: Element | null) => {
  const [boxSize, setBoxSize] = React.useState<ResizeObserverSize>();

  React.useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (entry.borderBoxSize) {
          setBoxSize(entry.borderBoxSize[0]);
        }
      }
    });

    if (element) {
      resizeObserver.observe(element);
    }

    return () => {
      if (element) {
        resizeObserver.unobserve(element);
      }
    };
  }, [element]);

  return boxSize;
};
